import React from 'react';
import styles from './css/index.module.css';

const AiWardenAssessPanel = ({ onSubmit, submitting }) => {
    return (
        <>
            <p className={styles.aiWardenTip}>
                Assess selected scope from a diligence perspective using retrieved evidence only (maturity, strengths/weaknesses, risks, confidence, and gaps).
            </p>
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitting ? 'Thinking…' : 'Assess This Area'}
                </button>
                <span className={styles.aiWardenTip}>Assessment uses only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenAssessPanel;
